module.exports = __webpack_public_path__ + "static/prize-xbox-min-c8fed551c7817902dc6450ca005f31b4.png";